export * from './colorMap';
